import React, { FC, useContext } from 'react';
import { Box, Collapse, IconButton, SxProps, Typography } from '@mui/material';
import CustomInfoCardRow from './CustomInfoCardRow';
import { InfoBlock } from './infoBlock';
import { Element } from 'react-scroll';
import { ReactComponent as ArrowDownIcon } from '../../images/arrow-down.svg';
import { ReactComponent as ArrowUpIcon } from '../../images/arrow-up.svg';
import SquareAvatar from '../SquareAvatar/SquareAvatar';
import { GlobalContext } from '../../contexts/globalContext';
import ViewWatchLists from '../ViewWatchLists/ViewWatchLists';

interface CustomInfoCardProps {
    infoBlocks: InfoBlock[];
    containerStyles?: SxProps;
}

const CustomInfoCard: FC<CustomInfoCardProps> = ({ infoBlocks, containerStyles }) => {
    const { reportData } = useContext(GlobalContext);
    const [expanded, setExpanded] = React.useState(infoBlocks[0].initialExpanded);
    return (
        <Box
            className="card-shadow"
            sx={{
                p: '24px',
                borderRadius: '8px',
                width: '100%',
                cursor: 'pointer',
                ...containerStyles,
            }}
            onClick={(event) => {
                if (!event['stopParentCollapsePropagation']) {
                    setExpanded(!expanded);
                }
            }}
        >
            {infoBlocks.map((block, blockIndex) => (
                <Element name={`${block.title}Info`} key={blockIndex}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box
                                sx={{
                                    width: '24px',
                                    height: '24px',
                                    p: '4px',
                                    borderRadius: '20px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                className="background-color-bl"
                            >
                                {block.icon}
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="s16w500" sx={{ mx: 1 }}>
                                    {`${block.title} (${block.items.length})`}
                                </Typography>
                                {block.watched && <ViewWatchLists watchLists={block.watchLists} />}
                            </Box>
                        </Box>
                        <IconButton onClick={() => setExpanded(!expanded)}>
                            {expanded ? <ArrowUpIcon /> : <ArrowDownIcon />}
                        </IconButton>
                    </Box>
                    <Collapse
                        in={Boolean(reportData.find) || expanded || block.watched}
                        timeout={Boolean(reportData.find) ? 0 : 'auto'}
                    >
                        <Box sx={{ mt: 2 }}>
                            {block.type && block.type === 'avatars' ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                                    {block.items.map((avatar, index) => (
                                        <SquareAvatar key={index} avatar={avatar} />
                                    ))}
                                </div>
                            ) : (
                                block.items.map((item, itemIndex) => <CustomInfoCardRow item={item} key={itemIndex} />)
                            )}
                        </Box>
                    </Collapse>
                </Element>
            ))}
        </Box>
    );
};

export default CustomInfoCard;
